exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app__loadingPlaceholder___2oLG-{position:relative}.app__loadingPlaceholder___2oLG- .app__text___3UtEM{color:#000!important;padding-top:60px;text-align:center;position:relative}.app__loadingPlaceholder___2oLG- .app__sub___1Olta{display:block;font-size:1em;font-weight:400;text-transform:none}.app__loadingPlaceholder___2oLG- .app__fa___2DuXs{font-style:normal;left:47.5%;position:absolute;top:0}", ""]);

// exports
exports.locals = {
	"loadingPlaceholder": "app__loadingPlaceholder___2oLG-",
	"text": "app__text___3UtEM",
	"sub": "app__sub___1Olta",
	"fa": "app__fa___2DuXs"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./app/components/app.css
// module id = 314
// module chunks = 1